import { useNavigate } from 'react-router-dom';
import logo from '../../assets/images/logo.png';
import useHeader from '../../hooks/useHeader';
import './index.css';
import '../../index.css';
import useUserContext from '../../hooks/useUserContext';

/**
 * Header component that renders the main title and a search bar.
 * The search bar allows the user to input a query and navigate to the search results page
 * when they press Enter.
 */
const Header = () => {
  const { val, handleInputChange, handleKeyDown, handleSignOut } = useHeader();
  const { user: currentUser } = useUserContext();
  const navigate = useNavigate();
  return (
    <div id='header' className='header'>
      <div></div>
      <img className='headerLogo' alt='logo' src={logo} />
      <div className='title'>Dolphin Cove</div>
      <input
        className='searchBar'
        id='searchBar'
        placeholder='Search ...'
        type='text'
        value={val}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
      />
      <button onClick={handleSignOut} className='logout-button'>
        LOG OUT
      </button>
      <button
        className='view-profile-button'
        onClick={() => navigate(`/user/${currentUser.username}`)}>
        VIEW PROFILE
      </button>
    </div>
  );
};

export default Header;
